import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3035d350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = { class: "jieti1" }
const _hoisted_4 = { class: "jieti2" }
const _hoisted_5 = { class: "jieti3" }
const _hoisted_6 = { class: "jieti3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibu1" }, " 1.2009年10月至2011年9月，连续招募23家医院包括13家儿童医院和10家成人医院皮肤科门诊皮肤及软组织感染（SSTI）患者，分离金黄色葡萄球菌，按照2010年琼脂稀释法评估对 16 种抗菌药物的敏感性 "),
  /*#__PURE__*/_createElementVNode("div", { class: "dibu2" }, " 2.2019年5月至2021年8月，连续招募中国7个地理区域22家三级儿科医院皮肤科确诊的SSTI患者。分离金黄色葡萄球菌，采用微量肉汤稀释法评估其对15种抗菌药物的敏感性 ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibutwo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibutwo1" }, " 1.Liu Y, et al. Emerg Microbes Infect. 2016 Dec 21;5(12):e127. "),
  /*#__PURE__*/_createElementVNode("div", { class: "dibutwo2" }, " 2. Su W, et al. Front Cell Infect Microbiol. 2023 Jul 13;13 1179509. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h20" }, null, -1))
const _hoisted_11 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "1.8667rem",
              src: require('../assets/b1.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "8.3333rem",
              height: "5.16rem",
              src: require('../assets/b2.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "1.3467rem",
              src: require('../assets/b3.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "8.3333rem",
              height: "4.3867rem",
              src: require('../assets/b4.png')
            }, null, 8, ["src"])
          ]),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_image, {
            onClick: $options.bijiao,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/chakanliaoxiao.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}